document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector('[data-load-workflow-js]')) return;

  function getCurrentUserId() {
    const el = document.querySelector("[data-current-user-id]");
    const userId = el?.dataset?.currentUserId || null;
    return userId ? parseInt(userId, 10) : null;
  }

  function setPeriod(days) {
    const today = new Date();
    const start = new Date();

    const gteqField = document.getElementById("created_at_gteq_field");
    const lteqField = document.getElementById("created_at_lteq_field");
    if (!gteqField || !lteqField) return;

    if (days === "0") {
      const dateStr = today.toISOString().slice(0, 10);
      gteqField.value = dateStr;
      lteqField.value = dateStr;
    } else if (days) {
      start.setDate(today.getDate() - parseInt(days, 10) + 1);
      gteqField.value = start.toISOString().slice(0, 10);
      lteqField.value = today.toISOString().slice(0, 10);
    }
  }

  const periodSelect = document.getElementById("period_select");
  if (periodSelect) {
    const gteqField = document.getElementById("created_at_gteq_field");
    const lteqField = document.getElementById("created_at_lteq_field");

    periodSelect.addEventListener("change", function () {
      const hidden = document.getElementById("period_hidden");
      if (hidden) hidden.value = this.value;

      if (this.value) {
        setPeriod(this.value);
      } else {
              if (gteqField) gteqField.value = "";
              if (lteqField) lteqField.value = "";
      }
    });

    const gteqEmpty = !gteqField || !gteqField.value;
    const lteqEmpty = !lteqField || !lteqField.value;
    if (gteqEmpty && lteqEmpty && periodSelect.value) {
      setPeriod(periodSelect.value);
    }
  }

  // 一括チェックボックス制御
  const checkAll = document.getElementById("check_all");
  const rowChecks = document.querySelectorAll(".row-check");

  if (checkAll) {
    checkAll.addEventListener("change", function () {
      rowChecks.forEach(cb => (cb.checked = this.checked));
    });
  }

  rowChecks.forEach(cb => {
    cb.addEventListener("change", function () {
      const allChecked = Array.from(rowChecks).every(cb => cb.checked);
      if (checkAll) checkAll.checked = allChecked;
    });
  });

  // 共通処理
  function handleBulkAction({ url, confirmMessage }) {
    return function () {
      const checked = Array.from(document.querySelectorAll(".row-check:checked"));
      if (checked.length === 0) {
        alert(confirmMessage.replace("まとめて", "") + "する申請を選択してください。");
        return;
      }
      if (!confirm(confirmMessage)) return;

      const ids = checked.map(el => el.value);
      const stepNumbers = checked.map(el => el.closest("tr")?.dataset.stepNumber || "");

      const payload = ids.map((id, i) => ({
        id: id,
        step_number: stepNumbers[i]
      }));

      const params = new URLSearchParams();
      payload.forEach(p => {
        params.append("approvals[][id]", p.id);
        params.append("approvals[][step_number]", p.step_number);
      });

      Spinner.show();

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: params
      }).then(response => {
        if (response.ok) {
          location.reload();
        } else {
          return response.text().then(text => {
            Spinner.hide();
            try {
              const data = JSON.parse(text);
              alert(data.error || "処理に失敗しました。");
            } catch (e) {
              alert("処理に失敗しました。");
            }
          });
        }
      }).catch(() => {
        Spinner.hide();
        alert("処理に失敗しました。");
      });
    };
  }

  // ボタンにイベント登録
  const bulkApproveBtn = document.getElementById("bulk-approve");
  if (bulkApproveBtn) {
    bulkApproveBtn.addEventListener("click", handleBulkAction({
      url: "/workflow_applications/bulk_step_approve",
      confirmMessage: "選択した申請をまとめて承認しますか？"
    }));
  }

  const bulkRejectBtn = document.getElementById("bulk-reject");
  if (bulkRejectBtn) {
    bulkRejectBtn.addEventListener("click", handleBulkAction({
      url: "/workflow_applications/bulk_step_reject",
      confirmMessage: "選択した申請をまとめて否認しますか？"
    }));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const workflowTypeSelect = document.getElementById("workflow_type_number");
  const targetMonthInput = document.getElementById("target_month");
  const targetMonthField = targetMonthInput ? targetMonthInput.closest(".field") : null;

  if (!workflowTypeSelect || !targetMonthField) return;

  workflowTypeSelect.addEventListener("change", function () {
    const selectedValue = workflowTypeSelect.value;

    if (["1", "10", "20"].includes(selectedValue)) {
      targetMonthField.style.display = "none";
    } else {
      targetMonthField.style.display = "";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("csv-export-form");
  const button = document.getElementById("csv-export-button");
if (!form || !button) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    button.disabled = true;
    const originalValue = "CSV出力";
    button.value = "出力中...";

    const formData = new FormData(form);

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      }
    })
      .then(response => {
        return response.blob().then(blob => ({ blob, response }));
      })
      .then(({ blob, response }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        const disposition = response.headers.get("Content-Disposition");
        let filename = "download.csv";
        if (disposition) {
          // filename*（優先）を取得
          const filenameStarMatch = disposition.match(/filename\*\=UTF-8''([^;]+)/);
          if (filenameStarMatch) {
            filename = decodeURIComponent(filenameStarMatch[1]);
          } else {
            // 通常のfilename
            const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch) {
              filename = filenameMatch[1];
            }
          }
        }

        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error("CSVダウンロードに失敗しました:", error);
        alert("CSVの出力に失敗しました。");
      })
      .finally(() => {
        button.disabled = false;
        button.value = originalValue;
      });
  });
});
